const EXTENSION_ICON_MAP: Record<string, string> = {
  pdf: '/icons/PDF.png',
  txt: '/icons/txt.svg',
  log: '/icons/txt.svg',
  md: '/icons/md.svg',
  csv: '/icons/csv.svg',
  json: '/icons/json.svg',
  xml: '/icons/xml.svg',
  html: '/icons/html.svg',
}

export function getFileIconPath(fileName: string): string {
  const ext = fileName.split('.').pop()?.toLowerCase() ?? ''
  return EXTENSION_ICON_MAP[ext] ?? '/icons/file.svg'
}
